<template>
    <div class="storeData">
        <div class="storeData_nap">
            <el-date-picker
                v-model="dateDay"
                value-format="yyyy-MM-dd"
                type="daterange"
                @change="dateRangeChange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
            <div class="name" style="margin-left:20px">全部显示：</div>
            <el-select
                v-model="showAll"
                placeholder="全部显示"
                @change="showIcon"
            >
                <el-option label="是" value="YES"> </el-option>
                <el-option label="否" value="NO"> </el-option>
            </el-select>
        </div>

        <div class="storeData_pane">
            <div style="width: 1200px">
                <div
                    class="my-charts"
                    ref="myChart"
                    id="myChart"
                    :style="{ width: chartsWidth, height: '600px' }"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
import { analyseOperLog } from "../../utils/interface";

export default {
    name: "operLogAnalyse",
    components: {},
    data() {
        return {
            tabPosition: "",
            dateDay: [],
            chartsWidth: "",
            startTime: "",
            endTime: "",
            loading: false,
            logList: [],
            showAll: "YES",
            myChart: {},
            keyName: [],
            keyNameChart: {}
        };
    },
    created() {
        this.chartsWidth = window.innerWidth - 210 + "px";
    },
    mounted() {
        this.currentTime();
        this.nextTime();
        this.init();
    },
    methods: {
        init() {
            this.dateDay.push(new Date(this.startTime));
            this.dateDay.push(new Date(this.endTime));
            this.getList();
        },
        dateRangeChange(date) {
            this.startTime = date[0];
            this.endTime = date[1];
            this.getList();
        },
        nextTime() {
            let end = new Date();
            end = this.formatDate(end, "yyyy-MM-dd");
            end = this.getUpMonth(end);
            return end;
        },
        currentTime() {
            let start = new Date();
            this.endTime = this.formatDate(start, "yyyy-MM-dd");
        },
        formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
            date = new Date(date);
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            }
            let o = {
                "M+": date.getMonth() + 1,
                "d+": date.getDate(),
                "h+": date.getHours(),
                "m+": date.getMinutes(),
                "s+": date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + "";
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length === 1 ? str : "0" + str
                    );
                }
            }
            return fmt;
        },
        getUpMonth(data) {
            let arr = data.split("-");
            let year = arr[0]; // 获取当前日期的年份
            let month = arr[1]; // 获取当前日期的月份
            let day = arr[2]; // 获取当前日期的日
            let year2 = year;
            let month2 = parseInt(month) - 1;
            if (month2 === 13) {
                year2 = parseInt(year2) + 1;
                month2 = 1;
            }
            let day2 = day;
            let days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = "0" + month2;
            }
            this.startTime = year2 + "-" + month2 + "-" + day2;
        },
        getList() {
            this.loading = true;
            let data = {
                startTime: this.startTime,
                endTime: this.endTime
            };
            analyseOperLog(data).then(res => {
                if (res.success) {
                    let xData = res.data.xDate;
                    let categoryData = [];
                    let series = [];
                    for (let key in res.data.yDate) {
                        //此处遍历map
                        this.keyName.push(key);
                        categoryData.push(key);
                        // res.data.yDate.selected = false
                        series.push({
                            name: key,
                            type: "line",
                            data: res.data.yDate[key],
                            smooth: true
                        });
                    }
                    this.drawLine(xData, categoryData, series);
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
        drawLine(xData, categoryData, series) {
            let that = this;
            // 基于准备好的dom，初始化echarts实例
            this.myChart = this.$echarts.init(this.$refs.myChart);
            this.myChart.clear();
            // 绘制图表
            this.myChart.setOption({
                // title: {
                //   text: "当周批转量和报备量",
                //   left: "5%",
                // },
                tooltip: {
                    trigger: "axis",
                    position: function(point, params, dom, rect, size) {
                        // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                        // 提示框位置
                        var x = 0; // x坐标位置
                        var y = 0; // y坐标位置 // 当前鼠标位置

                        var pointX = point[0];
                        var pointY = point[1]; // 外层div大小 // var viewWidth = size.viewSize[0]; // var viewHeight = size.viewSize[1]; // 提示框大小

                        var boxWidth = size.contentSize[0];
                        var boxHeight = size.contentSize[1]; // boxWidth > pointX 说明鼠标左边放不下提示框

                        if (boxWidth > pointX) {
                            x = pointX + 10;
                        } else {
                            // 左边放的下
                            x = pointX - boxWidth - 10;
                        } // boxHeight > pointY 说明鼠标上边放不下提示框

                        if (boxHeight > pointY) {
                            y = 5;
                            console.log('3', );
                        } else {
                            // 上边放得下
                            y = pointY - boxHeight;
                        }

                        return [x, y];
                    }
                },
                legend: {
                    data: categoryData,
                    right: "5%",
                    selected: that.keyNameChart
                },
                grid: {
                    left: "5%",
                    right: "6%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xData,
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 0.1
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#999",
                            width: 0.1
                        }
                    }
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#999",
                            width: 0.1
                        }
                    }
                },
                series
            });
        },
        showIcon(value) {
            let selectArr = this.myChart.getOption().legend[0].data;
            console.log("---------------------1---------------------");
            console.log(selectArr);
            let val = null;
            this.getList();
            if (value === "YES") {
                val = true;
                this.keyName.forEach(el => {
                    this.keyNameChart[el] = true;
                });
            } else {
                this.keyName.forEach(el => {
                    this.keyNameChart[el] = false;
                });
                val = false;
            }
            var obj = {};
            for (var key in selectArr) {
                obj[selectArr[key]] = val;
            }
            console.log("---------------------3---------------------");
            console.log(obj);
            //设定图例是否选中的结果 赋值给 option.legend.selected
            let option = this.myChart.getOption();
            console.log(option);
            option.legend.selected = obj;
            this.myChart.clear();
            this.myChart.setOption(option);
        }
    }
};
</script>
<style scoped lang="less">
.storeData {
    padding: 20px;
    background: #fff;
    margin: 0 20px;
    .storeData_nap {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        margin-bottom: 20px;
    }
}

//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input {
    position: relative !important;
}

//修改控件自带的css
.hide_input /deep/ .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
}

.hide_input /deep/ .el-input__prefix {
    left: 0;
    width: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/logManage/operLogAnalyse.vue